import ModulLiveClass from "@/modules/live_class/components/LiveClass";
import ModulLiveClassForm from "@/modules/live_class/components/Form";

export default [
    {
        path: "/live-class",
        name: "LiveClass",
        component: ModulLiveClass,
    },
    {
        path: "/live-class/form",
        name: "LiveClassForm",
        component: ModulLiveClassForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/live_class/router/liveclass.js